module.exports = __webpack_public_path__ + "img/sampleGraph5.2bfa012d.png";